import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { COAUTHOR_SHAPE, CONTENT_ITEM, LANGUAGES } from 'config/types/prop';
import removeLinks from 'utils/removeLinks';
import setInnerHTML from 'utils/setInnerHTML';
import Thumbnail from 'components/thumbnail';
import withStyles from 'isomorphic-style-loader/withStyles';
import Link from 'components/link';

import styles from './author-overview.css';

const AuthorOverview = ({
  descriptionFiltered,
  displayName,
  avatarUrl,
  relativePath,
  isInProductMagazine,
}) => (
  <section className={styles.authorOverview}>
    <div className={styles.header}>
      <div className={styles.photoContainer}>
        <Thumbnail
          alt="Author Headshot"
          height="140"
          hideLinkFromAccessibility
          isLazyLoading
          originalSource={avatarUrl}
          position="authorOverview"
          width="140"
          wrapperClasses={styles.photo}
          {...isInProductMagazine ? {} : { imageLink: relativePath }}
        />
      </div>
      <div className={styles.textContainer}>
        {isInProductMagazine ?
          <span className={styles.authorName}>{displayName}</span> :
          <Link
            to={relativePath}
            className={styles.authorName}
          >
            {displayName}
          </Link>
        }
        <div
          className={styles.description}
          dangerouslySetInnerHTML={setInnerHTML( // eslint-disable-line react/no-danger
            descriptionFiltered,
          )}
        />
      </div>
    </div>
    <div
      className={styles.descriptionMobile}
      dangerouslySetInnerHTML={setInnerHTML( // eslint-disable-line react/no-danger
        descriptionFiltered,
      )}
    />
  </section>
);

AuthorOverview.propTypes = {
  articles: PropTypes.arrayOf(
    PropTypes.shape(CONTENT_ITEM),
  ).isRequired,
  descriptionFiltered: PropTypes.string.isRequired,
  currentEdition: LANGUAGES.isRequired,
  isInProductMagazine: PropTypes.bool.isRequired,
  ...COAUTHOR_SHAPE,
};

const mapStateToProps = (state, props) => {
  const { currentEdition, description, descriptions, isInProductMagazine } = props;
  const filterLinksIfNeeded = isInProductMagazine ? removeLinks : (content) => content;
  const descriptionFiltered = filterLinksIfNeeded(descriptions[currentEdition] || description);
  return {
    descriptionFiltered,
  };
};

const withRedux = connect(mapStateToProps);

export default withRedux(withStyles(styles)(AuthorOverview));
